import { render, staticRenderFns } from "./DeclareLock.vue?vue&type=template&id=4de5d2f6&scoped=true&"
import script from "./DeclareLock.vue?vue&type=script&lang=js&"
export * from "./DeclareLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5d2f6",
  null
  
)

export default component.exports